import React from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { development } from "../../libs/utils/Const";
const styles = StyleSheet.create({


    tableContainer: {
        width: '97%',
        margin: '15 auto',
    },
    content: {
        flexDirection: 'row',
        display: 'flex',
    },
    col: {
        width: '100%',
    },
    col10: {
        width: '83.3%',
    },
    col8: {
        width: '66.6%',
    },
    col7: {
        width: '58.3%',
    },
    col6: {
        width: '50%',
    },
    col5: {
        width: '41.6%',
    },
    col4: {
        width: '33.3%',
    },
    col3: {
        width: '25%',
    },
    col2: {
        width: '16.6%',
    },
    col1: {
        width: '8.3%',
    },
    logo: {
        width: 110,
        height: 50,
    },
    textLeft: {
        textAlign: 'left',
        paddingTop: '1px',
        fontSize: 9,
    },
    textRight: {
        textAlign: 'right',
        padding: '1px 5px 0px 0px',
        fontSize: 9,
    }
});

const headerStyles = StyleSheet.create({
    mainTitle: {
        fontSize: 24,
        fontWeight: 'bold',
        color: '#004B87',
        textAlign: 'center',
        marginBottom: 4,
        letterSpacing: 1
    },

    subtitle: {
        fontSize: 12,
        color: '#333333',
        textAlign: 'center',
        marginBottom: 12
    },

    sectionHeader: {
        backgroundColor: '#0B5D8F',
        padding: 6,
        marginBottom: 8
    },

    sectionHeaderText: {
        color: '#FFFFFF',
        fontSize:9,
        fontWeight: 'bold',
        letterSpacing: 0.5
    },

    dataRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingHorizontal: 10,
        paddingVertical: 4,
    },

    dataLabel: {
        fontSize: 8,
        color: '#333333',
        flex: 1
    },

    dataValue: {
        fontSize: 8,
        color: '#000000',
        flex: 1,
        textAlign: 'right'
    },

    detailHeader: {
        backgroundColor: '#0B5D8F',
        padding: 6,
        marginTop: 8
    },

    detailHeaderText: {
        color: '#FFFFFF',
        fontSize: 11,
        fontWeight: 'bold',
        letterSpacing: 0.5
    },

    headerContainer: {
        padding: 10,
        marginBottom: 15
    }
});

const TitleModal = (docType, header) => {
    let title = '';
    switch (docType) {
        case '17':
            title = 'Orden de Venta ';
            break;
        case '15':
            title = 'Entrega ';
            break;
        case '13':
            if (header.DocSubType === '--' && header.isIns === 'N') {
                title = 'Factura ';
            } else if (header.DocSubType === 'DN') {
                title = 'Nota de Débito ';
            } else if (header.isIns === 'Y') {
                title = 'Factura de reserva de clientes';
            }
            break;
        case '16':
            title = 'Devolución ';
            break;
        case '21':
            title = 'Devolución de Mercancía ';
            break;
        case '14':
            title = 'Nota de Crédito ';
            break;
        case 'payment':
            title = 'Pagos Recibidos ';
            break;
        case 'transfers':
            title = 'Traslado de Mercancía ';
            break;
        case 'transfersRequest':
            title = 'Solicitud de Traslado ';
            break;
        case 'transfersEntry':
            title = 'Entrada de Mercancía ';
            break;
        case 'transfersOutput':
            title = 'Salida de Mercancía ';
            break;
        case 'invoiceAuthorization':
            title = 'Borrador [Pendiente] ';
            break;
        case 'invoiceBorrador':
            title = 'Borrador [Autorizado] ';
            break;
        case '22':
            title = 'Orden de Compra ';
            break;
        case '20':
            title = 'Entrada de Mercancía ';
            break;
        case 'SalesHelmets':
            title = 'Entrada de Mercancía Cascos';
            break;
        case 'ExitHelmets':
            title = 'Salida de Mercancía Cascos';
            break;
        case 'PurchaseRequest':
            title = 'Solicitud de Compra ';
            break;
        case 'inventoryRevaluation':
            title = 'Revalorización de Inventario ';
            break;
        case '18':
            title = 'Factura de Proveedores ';
            break;
        case 'outgoingPayment':
            title = 'Pagos Efectuados';
            break;
        case 'invoiceReserve':
            title = 'Factura de reserva de clientes';
            break;
        case '23':
            title = 'Oferta de venta ';
            break;
        case '24':
            title = 'Pago recibido ';
            break;
        case '67':
            title = 'Traslado de Mercancía ';
            break;
        case '59':
            title = 'Entrada de Mercancía ';
            break;
        case '60':
            title = 'Salida de Mercancía ';
            break;
        case '1250000001':
            title = 'Solicitud de traslado';
            break;

        default:

    }
    return title;
};

const formatDocTime = (time) => {
    if (!time) return '';
    const t = time.toString().padStart(4, '0');
    const hh = t.substring(0, 2);
    const mm = t.substring(2, 4);
    return `${hh}:${mm}`;
};


const ReportTitle = ({ header, view, _user, items }) => {
    let weightTotal = 0;
    for (const item of items) { weightTotal += (Number(item.Weight || 0) * Number(item.Quantity || 0)); }
    if (view === 'creditNote' && header.U_BPP_MDTD === 'DV' ) {
        return (
            <>
                <View style={styles.tableContainer}>
                    <View style={[styles.content]}>
                        <View style={[styles.col]}>
                            <View style={[styles.content, { paddingBottom: '10px' }]}>
                                <View style={[styles.col4]}>
                                    <Image style={styles.logo} src={development ? require('../../images/logo_draft.png') : require('../../images/logo_EMPRESA.png')} />
                                </View>
                                <View style={[styles.col8, { paddingLeft: '10px', paddingTop: '5px' }]}>
                                    <Text style={{ fontSize: '7px' }}>AV. EL POLO NRO. 397 (ESQ. JR. EMANCIPACION 103 -107)-SANTIAGO DE SURCO-LIMA</Text>
                                    <Text style={{ fontSize: '7px' }}>CELULAR: (01)617-1717</Text>
                                    <Text style={{ fontSize: '7px' }}>CORREO: coordinador.cc@grupollamagas.pe, super.callcenter02@grupollamagas.p</Text>
                                </View>
                                <View style={[styles.col4, { paddingRight: '10px', paddingTop: '5px', borderWidth: '1', borderColor: '#000000', }]}>
                                    <Text style={{ fontSize: '7px', marginTop: '5px', textAlign: 'center' }}>
                                        {`N° ${header.DocNum}`}
                                    </Text>
                                    <Text style={{ fontSize: '7px', fontWeight: 'bold', textAlign: 'center' }}>
                                        {'DEVOLUCIÓN DE CERTIFICADO'}
                                    </Text>
                                    <Text style={{ fontSize: '7px', textAlign: 'center' }}>
                                        {'DE CESION EN USO'}
                                    </Text>
                                </View>
                            </View>

                            <View style={[styles.content, { paddingLeft: '5px', paddingTop: '10px', borderTop: '1px solid black', marginTop: '10px' }]}>
                                <View style={[styles.col6]}>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px', flexShrink: 1 }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>RECIBIDO DE</Text>
                                        <Text style={{ fontSize: '7px', flex: 1, flexWrap: 'wrap' }}>: {header.CardName || ''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>IDENTIFICADO (DNI)</Text>
                                        <Text style={{ fontSize: '7px' }}>: {header.LicTradNum || ''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>EN LA FECHA Y HORA</Text>
                                        <Text style={{ fontSize: '7px' }}>: {header.DocDate || ''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>POR EL IMPORTE DE</Text>
                                        <Text style={{ fontSize: '7px' }}>: S/. {header.DocTotal ? parseFloat(header.DocTotal).toFixed(2) : ''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>POR CONCEPTO DE</Text>
                                        <Text style={{ fontSize: '7px' }}>: {header.Remarks || 'Garantía por Cesión de Uso'}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>DIRECCIÓN</Text>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ fontSize: '7px' }}>: {header.Address ? header.Address.split('\n')[0] || '' : ''}</Text>
                                            <Text style={{ fontSize: '7px' }}>{header.Address ? header.Address.split('\n')[1] || '' : ''}</Text>
                                        </View>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>REMITIDO AL CORREO</Text>
                                        <Text style={{ fontSize: '7px' }}>: {header.E_Mail || ''}</Text>
                                    </View>
                                </View>

                                <View style={[styles.col6, { paddingLeft: '20px' }]}>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>CESIÓN EN USO</Text>
                                        <Text style={{ fontSize: '7px' }}>: CU {header.U_BPP_MDTO || ''} - {header.U_BPP_MDSO || ''} - {header.U_BPP_MDCO || ''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>SUCURSAL</Text>
                                        <Text style={{ fontSize: '7px' }}>: {_user?.Sucursal || ''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>RUTA</Text>
                                        <Text style={{ fontSize: '7px' }}>: {_user?.Sucursal || ''}</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </>
        );
    }

    if (view === 'invoice' && header.U_BPP_MDTD === 'CU') {
        return (
            <>
                <View style={styles.tableContainer}>
                    <View style={[styles.content]}>
                        <View style={[styles.col]}>
                            <View style={[styles.content, { paddingBottom: '10px' }]}>
                                <View style={[styles.col4]}>
                                    <Image style={styles.logo} src={development ? require('../../images/logo_draft.png') : require('../../images/logo_EMPRESA.png')} />
                                </View>
                                <View style={[styles.col8, { paddingLeft: '10px', paddingTop: '5px' }]}>
                                    <Text style={{ fontSize: '7px', fontWeight: '600' }}>LLAMA GAS S.A. - RUC: 20100366747</Text>
                                    <Text style={{ fontSize: '7px' }}>AV. EL POLO NRO. 397 (ESQ. JR. EMANCIPACION 103 -107)-SANTIAGO DE SURCO-L</Text>
                                    <Text style={{ fontSize: '7px' }}>(01)617-1717</Text>
                                    <Text style={{ fontSize: '7px' }}>coordinador.cc@grupollamagas.pe, super.callcenter02@grupollamagas.pe, coord.callcen</Text>
                                </View>
                                <View style={[styles.col4, { paddingRight: '10px', paddingTop: '5px', borderWidth: '1', borderColor: '#000000', }]}>
                                    <Text style={{ fontSize: '7px', marginTop: '5px', textAlign: 'center' }}>
                                        {`N° ${header.DocNum}`}
                                    </Text>
                                    <Text style={{ fontSize: '7px', fontWeight: 'bold', textAlign: 'center' }}>
                                        {'CERTIFICADO DE GARANTIA'}
                                    </Text>
                                    <Text style={{ fontSize: '7px', textAlign: 'center' }}>
                                        {'DE CESION EN USO'}
                                    </Text>
                                </View>
                            </View>

                            <View style={[styles.content, { paddingLeft: '5px', paddingTop: '10px', borderTop: '1px solid black', marginTop: '10px' }]}>
                                <View style={[styles.col6]}>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px', flexShrink: 1 }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>RECIBIDO DE</Text>
                                        <Text style={{ fontSize: '7px', flex: 1, flexWrap: 'wrap' }}>: {header.CardName || ''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>IDENTIFICADO (DOI/DNI(RUC))</Text>
                                        <Text style={{ fontSize: '7px' }}>: {header.LicTradNum || ''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>EN LA FECHA Y HORA</Text>
                                        <Text style={{ fontSize: '7px' }}>: {header.DocDate || ''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>POR EL IMPORTE DE</Text>
                                        <Text style={{ fontSize: '7px' }}>: S/. {header.DocTotal ? parseFloat(header.DocTotal).toFixed(2) : ''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>POR CONCEPTO DE</Text>
                                        <Text style={{ fontSize: '7px', flex: 1, flexWrap: 'wrap' }}>: {header.Comments || 'Garantía por Cesión de Uso'}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>DIRECCIÓN</Text>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ fontSize: '7px' }}>: {header.Address ? header.Address.split('\n')[0] || '' : ''}</Text>
                                            <Text style={{ fontSize: '7px' }}>{header.Address ? header.Address.split('\n')[1] || '' : ''}</Text>
                                        </View>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>REMITIDO AL CORREO</Text>
                                        <Text style={{ fontSize: '7px', flex: 1, flexWrap: 'wrap' }}>: {header.E_Mail || ''}</Text>
                                    </View>
                                </View>

                                <View style={[styles.col6, { paddingLeft: '20px' }]}>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>SUCURSAL</Text>
                                        <Text style={{ fontSize: '7px' }}>: {header?.Sucursal || ''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>RUTA</Text>
                                        <Text style={{ fontSize: '7px' }}>: {header?.U_RS_Ruta || ''}</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </>
        );
    }


    if (view === 'orderSales' && header.U_RS_TIPOV === 'ENVASA') {
        return (
            <>
                <View style={headerStyles.headerContainer}>
                    <Text style={headerStyles.mainTitle}>ORDEN DE VENTA</Text>
                    <Text style={headerStyles.subtitle}>Control de entrega y recepción de cilindros</Text>
                    <View style={headerStyles.sectionHeader}>
                        <Text style={headerStyles.sectionHeaderText}>DATOS DE LA ORDEN</Text>
                    </View>
                    <View style={headerStyles.dataRow}>
                        <Text style={headerStyles.dataLabel}>Orden de venta N° (por sucursal / DocEntry): {header.DocNum} / {header.DocEntry}</Text>
                        <Text style={headerStyles.dataValue}>Unidad asignada: {_user?.Sucursal}</Text>
                    </View>
                    <View style={headerStyles.dataRow}>
                        <Text style={headerStyles.dataLabel}>Fecha del documento: {header.DocDate}</Text>
                        <Text style={headerStyles.dataValue}>Fecha de entrega: {header.DocDueDate}</Text>
                    </View>
                </View>
            </>
        )
    }

    if (view === 'invoice') {
        return (
            <>
                <View style={styles.tableContainer}>
                    <View style={[styles.content]}>
                        <View style={[styles.col]}>
                            <View style={[styles.content]}>
                                <View style={[styles.col6]}>
                                    <Image style={styles.logo} src={development ? require('../../images/logo_draft.png') : require('../../images/logo_EMPRESA.png')} />
                                </View>

                                <View style={[styles.col6, { textAlign: 'right', alignContent: 'right', fontWeight: 'bold', fontSize: '15px' }]}>
                                    <Text>{header.U_BPP_MDTD === "03" ? "BOLETA DE VENTA" : "FACTURA"}</Text>
                                </View>
                            </View>

                            <View style={[styles.content, { paddingLeft: '2px', paddingTop: '5px' }]}>
                                <View style={[styles.col6, styles.textLeft]}>
                                    <Text>{items && items.length > 0 && items[0].Almacen ? items[0].Almacen.toUpperCase() : 'SIN ALMACÉN'}</Text>
                                    <Text>{items && items.length > 0 && items[0].WhsCode ? `Código: ${items[0].WhsCode}` : ''}</Text>
                                    <Text>{items && items.length > 0 && items[0].ZipCode ? `C.P. ${items[0].ZipCode}` : ''}</Text>
                                </View>

                                <View style={[styles.col1, styles.textLeft]}>
                                </View>

                                <View style={[styles.col5, styles.textLeft]}>
                                    <View style={[styles.content]}>
                                        <View style={[styles.col7]}>
                                            <Text>N° </Text>
                                        </View>
                                        <View style={[styles.col5]}>
                                            <Text style={{ fontStyle: 'bold' }}>{`${header.DocEntry}`}</Text>
                                        </View>
                                    </View>
                                    <View style={[styles.content]}>
                                        <View style={[styles.col7]}>
                                            <Text>Estatus:</Text>
                                        </View>
                                        <View style={[styles.col5]}>
                                            <Text style={{ fontStyle: 'bold' }}>{`${header.DocStatus === 'C' ? 'Cerrado' : 'Abierto' || ''}`}</Text>
                                        </View>
                                    </View>
                                    <View style={[styles.content]}>
                                        <View style={[styles.col7]}>
                                            <Text>Folio:</Text>
                                        </View>
                                        <View style={[styles.col5]}>
                                            <Text style={{ fontStyle: 'bold' }}>{`${header.NumAtCard || ''}`}</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>

                            <View style={[styles.content, { paddingLeft: '2px', paddingTop: '5px' }]}>
                                <View style={[styles.col5]}>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`Cliente: ${header.CardCode || ""} `}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`Nombre: ${header.CardName || ""} `}</Text>
                                    </View>
                                    <View >
                                        <Text style={[styles.textLeft]}>{`Dirección: ${header.Address || ""}`}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`RUT: ${header.LicTradNum || ""}`}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`Teléfono: ${header.Phone1 || ""}`}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`Contacto: ${header.CntntName || ""}`}</Text>
                                    </View>
                                </View>
                                <View style={[styles.col7]}>
                                    <View style={[styles.content]}>
                                        <View style={[styles.col4]}>
                                            <View>
                                                <Text style={[styles.textRight]}>{`Fecha: `}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textRight]}>{`Condición de Pago: `}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textRight]}>{`Moneda: `}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textRight]}>{`Lugar de entrega: `}</Text>
                                            </View>
                                        </View>
                                        <View style={[styles.col8]}>
                                            <View>
                                                <Text style={[styles.textLeft]}>{`${header.DocDate || " "}`}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textLeft]}>{`${header.condicionesPago || " "}`}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textLeft]}>{`${header.DocCur || header.DocCurr || " "}`}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textLeft]}>{`${header.Address2 || " "}`}</Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </>
        );
    }

    if (view === 'debitNote') {
        return (
            <>
                <View style={styles.tableContainer}>
                    <View style={[styles.content]}>
                        <View style={[styles.col]}>
                            <View style={[styles.content, { paddingBottom: '10px' }]}>
                                <View style={[styles.col4]}>
                                    <Image style={styles.logo} src={development ? require('../../images/logo_draft.png') : require('../../images/logo_EMPRESA.png')} />
                                </View>

                                <View style={[styles.col8, { paddingLeft: '10px', paddingTop: '5px' }]}>
                                    <Text style={{ fontSize: '7px', fontWeight: '600', textAlign: 'center' }}>LLAMA GAS S.A.</Text>
                                    <Text style={{ fontSize: '7px', textAlign: 'center' }}>AV. EL POLO NRO. 397 (ESQ. JR. EMANCIPACION 103 -107)</Text>
                                    <Text style={{ fontSize: '7px', textAlign: 'center' }}>SANTIAGO DE SURCO - LIMA</Text>
                                    <Text style={{ fontSize: '7px', fontWeight: '600' }}>TELEFONO(S): 6171700</Text>
                                    <Text style={{ fontSize: '7px' }}>PAGINA WEB: www.llamagas.com.pe</Text>
                                    <Text style={{ fontSize: '7px' }}>E-MAIL:  sac@grupollamagas.pe</Text>
                                    <Text style={{ fontSize: '7px' }}>SUCURSAL: {_user?.Sucursal || ''}</Text>
                                    <Text style={{ fontSize: '7px' }}>DIRECCIÓN SUCURSAL: {_user?.DireccionSucursal || ''}</Text>
                                </View>

                                <View style={[styles.col4, { paddingRight: '10px', paddingTop: '5px' }]}>
                                    <View style={{ borderWidth: '1', borderColor: '#000000', padding: '5px' }}>
                                        <Text style={{ fontSize: '7px', textAlign: 'center' }}>{'RUC: 20100366747'}</Text>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', textAlign: 'center' }}>{'NOTA DE DÉBITO'}</Text>
                                        <Text style={{ fontSize: '7px', textAlign: 'center' }}>{'ELECTRONICA'}</Text>
                                    </View>
                                </View>

                            </View>

                            <View style={[styles.content, { paddingLeft: '5px', paddingTop: '10px', border: '1px solid black', marginTop: '10px' }]}>
                                <View style={{ display: 'flex', flexDirection: 'row' }}>
                                    <View style={{ width: '50%' }}>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>CLIENTE</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.CardName || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '48%' }}>DIRECCIÓN</Text>
                                            <Text style={{ fontSize: '7px' }}>: {header.Address || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>RUC</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.LicTradNum || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>FECHA DE EMISIÓN</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.DocDate || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>HORA DE EMISIÓN</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {formatDocTime(header.DocTime) || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>FECHA DE VENCIMIENTO</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.DocDueDate || ''}</Text>
                                        </View>
                                    </View>

                                    <View style={{ width: '50%', paddingLeft: '20px', paddingTop: '41px' }}>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>MONEDA</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.DocCur || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>FORMA DE PAGO</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.condicionesPago || ''}</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>

                            <View style={[styles.content, { paddingLeft: '5px', paddingTop: '10px', border: '1px solid black', marginTop: '10px' }]}>
                                <View style={[styles.col6]}>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', textAlign: 'center' }}>DOCUMENTO REFERENCIA</Text>
                                        <Text style={{ fontSize: '7px', textAlign: 'center' }}>: {''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <View style={{ width: '70%', display: 'flex', flexDirection: 'row', borderWidth: 1, borderColor: '#000', justifyContent: 'center' }}>
                                            <View style={{ width: '70%', borderRightWidth: 1, borderColor: '#000', padding: '5px', textAlign: 'center' }}>
                                                <Text style={{ fontSize: '7px', fontWeight: 'bold', textAlign: 'center' }}>NÚMERO DOCUMENTO</Text>
                                                <Text style={{ fontSize: '7px', textAlign: 'center' }}>{header.DocNum || ''}</Text>
                                            </View>
                                            <View style={{ width: '70%', padding: '5px', textAlign: 'center' }}>
                                                <Text style={{ fontSize: '7px', fontWeight: 'bold', textAlign: 'center' }}>FECHA DOCUMENTO</Text>
                                                <Text style={{ fontSize: '7px', textAlign: 'center' }}>{header.DocDate || ''}</Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>

                                <View style={[styles.col6, { paddingLeft: '20px' }]}>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>COD. TIPO NOTA DE</Text>
                                        <Text style={{ fontSize: '7px' }}>: {''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>TIPO NOTA DE DÉBITO</Text>
                                        <Text style={{ fontSize: '7px' }}>: {''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>SUSTENTO</Text>
                                        <Text style={{ fontSize: '7px' }}>: {''}</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </>
        );
    }

    if (view === 'creditNote') {
        return (
            <>
                <View style={styles.tableContainer}>
                    <View style={[styles.content]}>
                        <View style={[styles.col]}>
                            <View style={[styles.content, { paddingBottom: '10px' }]}>
                                <View style={[styles.col4]}>
                                    <Image style={styles.logo} src={development ? require('../../images/logo_draft.png') : require('../../images/logo_EMPRESA.png')} />
                                </View>

                                <View style={[styles.col8, { paddingLeft: '10px', paddingTop: '5px' }]}>
                                    <Text style={{ fontSize: '7px', fontWeight: '600', textAlign: 'center' }}>LLAMA GAS S.A.</Text>
                                    <Text style={{ fontSize: '7px', textAlign: 'center' }}>AV. EL POLO NRO. 397 (ESQ. JR. EMANCIPACION 103 -107)</Text>
                                    <Text style={{ fontSize: '7px', textAlign: 'center' }}>SANTIAGO DE SURCO - LIMA</Text>
                                    <Text style={{ fontSize: '7px', fontWeight: '600' }}>TELEFONO(S): 6171700</Text>
                                    <Text style={{ fontSize: '7px' }}>PAGINA WEB: www.llamagas.com.pe</Text>
                                    <Text style={{ fontSize: '7px' }}>E-MAIL:  sac@grupollamagas.pe</Text>
                                    <Text style={{ fontSize: '7px' }}>SUCURSAL: {_user?.Sucursal || ''}</Text>
                                    <Text style={{ fontSize: '7px' }}>DIRECCIÓN SUCURSAL: {_user?.DireccionSucursal || ''}</Text>
                                </View>

                                <View style={[styles.col4, { paddingRight: '10px', paddingTop: '5px' }]}>
                                    <View style={{ borderWidth: '1', borderColor: '#000000', padding: '5px' }}>
                                        <Text style={{ fontSize: '7px', textAlign: 'center' }}>{'RUC: 20100366747'}</Text>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', textAlign: 'center' }}>{'NOTA DE CREDITO'}</Text>
                                        <Text style={{ fontSize: '7px', textAlign: 'center' }}>{'ELECTRONICA'}</Text>
                                    </View>
                                </View>

                            </View>

                            <View style={[styles.content, { paddingLeft: '5px', paddingTop: '10px', border: '1px solid black', marginTop: '10px' }]}>
                                <View style={{ display: 'flex', flexDirection: 'row' }}>
                                    <View style={{ width: '50%' }}>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>CLIENTE</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.CardName || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '48%' }}>DIRECCIÓN</Text>
                                            <Text style={{ fontSize: '7px' }}>: {header.Address || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>RUC</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.LicTradNum || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>FECHA DE EMISIÓN</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.DocDate || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>HORA DE EMISIÓN</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {formatDocTime(header.DocTime) || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>FECHA DE VENCIMIENTO</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.DocDueDate || ''}</Text>
                                        </View>
                                    </View>

                                    <View style={{ width: '50%', paddingLeft: '20px', paddingTop: '41px' }}>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>MONEDA</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.DocCur || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>FORMA DE PAGO</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.condicionesPago || ''}</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>

                            <View style={[styles.content, { paddingLeft: '5px', paddingTop: '10px', border: '1px solid black', marginTop: '10px' }]}>
                                <View style={[styles.col6]}>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', textAlign: 'center' }}>DOCUMENTO REFERENCIA</Text>
                                        <Text style={{ fontSize: '7px', textAlign: 'center' }}>: {''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <View style={{ width: '70%', display: 'flex', flexDirection: 'row', borderWidth: 1, borderColor: '#000', justifyContent: 'center' }}>
                                            <View style={{ width: '70%', borderRightWidth: 1, borderColor: '#000', padding: '5px', textAlign: 'center' }}>
                                                <Text style={{ fontSize: '7px', fontWeight: 'bold', textAlign: 'center' }}>NÚMERO DOCUMENTO</Text>
                                                <Text style={{ fontSize: '7px', textAlign: 'center' }}>{header.DocNum || ''}</Text>
                                            </View>
                                            <View style={{ width: '70%', padding: '5px', textAlign: 'center' }}>
                                                <Text style={{ fontSize: '7px', fontWeight: 'bold', textAlign: 'center' }}>FECHA DOCUMENTO</Text>
                                                <Text style={{ fontSize: '7px', textAlign: 'center' }}>{header.DocDate || ''}</Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>

                                <View style={[styles.col6, { paddingLeft: '20px' }]}>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>COD. TIPO NOTA DE</Text>
                                        <Text style={{ fontSize: '7px' }}>: {''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>TIPO NOTA DE DÉBITO</Text>
                                        <Text style={{ fontSize: '7px' }}>: {''}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>SUSTENTO</Text>
                                        <Text style={{ fontSize: '7px' }}>: {''}</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </>
        );
    }

    if (view === 'invoice' && header.U_BPP_MDTD === '03') {
         return (
            <>
                <View style={styles.tableContainer}>
                    <View style={[styles.content]}>
                        <View style={[styles.col]}>
                            <View style={[styles.content, { paddingBottom: '10px' }]}>
                                <View style={[styles.col4]}>
                                    <Image style={styles.logo} src={development ? require('../../images/logo_draft.png') : require('../../images/logo_EMPRESA.png')} />
                                </View>

                                <View style={[styles.col8, { paddingLeft: '10px', paddingTop: '5px' }]}>
                                    <Text style={{ fontSize: '7px', fontWeight: '600', textAlign: 'center' }}>LLAMA GAS S.A.</Text>
                                    <Text style={{ fontSize: '7px', textAlign: 'center' }}>AV. EL POLO NRO. 397 (ESQ. JR. EMANCIPACION 103 -107)</Text>
                                    <Text style={{ fontSize: '7px', textAlign: 'center' }}>SANTIAGO DE SURCO - LIMA</Text>
                                    <Text style={{ fontSize: '7px', fontWeight: '600' }}>TELEFONO(S): 6171700</Text>
                                    <Text style={{ fontSize: '7px' }}>PAGINA WEB: www.llamagas.com.pe</Text>
                                    <Text style={{ fontSize: '7px' }}>E-MAIL:  sac@grupollamagas.pe</Text>
                                    <Text style={{ fontSize: '7px' }}>SUCURSAL: {_user?.Sucursal || ''}</Text>
                                    <Text style={{ fontSize: '7px' }}>DIRECCIÓN SUCURSAL: {_user?.DireccionSucursal || ''}</Text>
                                </View>

                                <View style={[styles.col4, { paddingRight: '10px', paddingTop: '5px' }]}>
                                    <View style={{ borderWidth: '1', borderColor: '#000000', padding: '5px' }}>
                                        <Text style={{ fontSize: '7px', textAlign: 'center' }}>{'RUC: 20100366747'}</Text>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', textAlign: 'center' }}>{'BOLETA DE VENTA'}</Text>
                                        <Text style={{ fontSize: '7px', textAlign: 'center' }}>{'ELECTRONICA'}</Text>
                                    </View>
                                </View>

                            </View>

                            <View style={[styles.content, { paddingLeft: '5px', paddingTop: '10px', border: '1px solid black', marginTop: '10px' }]}>
                                <View style={{ display: 'flex', flexDirection: 'row' }}>
                                    <View style={{ width: '50%' }}>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>CLIENTE</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.CardName || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '48%' }}>DIRECCIÓN</Text>
                                            <Text style={{ fontSize: '7px' }}>: {header.Address || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>RUC</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.LicTradNum || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>FECHA DE EMISIÓN</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.DocDate || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>HORA DE EMISIÓN</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {formatDocTime(header.DocTime) || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>FECHA DE VENCIMIENTO</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.DocDueDate || ''}</Text>
                                        </View>
                                    </View>

                                    <View style={{ width: '50%', paddingLeft: '20px', paddingTop: '41px' }}>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>MONEDA</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.DocCur || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>FORMA DE PAGO</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.condicionesPago || ''}</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </>
        );
    }

    if (view === 'invoice') {
         return (
            <>
                <View style={styles.tableContainer}>
                    <View style={[styles.content]}>
                        <View style={[styles.col]}>
                            <View style={[styles.content, { paddingBottom: '10px' }]}>
                                <View style={[styles.col4]}>
                                    <Image style={styles.logo} src={development ? require('../../images/logo_draft.png') : require('../../images/logo_EMPRESA.png')} />
                                </View>

                                <View style={[styles.col8, { paddingLeft: '10px', paddingTop: '5px' }]}>
                                    <Text style={{ fontSize: '7px', fontWeight: '600', textAlign: 'center' }}>LLAMA GAS S.A.</Text>
                                    <Text style={{ fontSize: '7px', textAlign: 'center' }}>AV. EL POLO NRO. 397 (ESQ. JR. EMANCIPACION 103 -107)</Text>
                                    <Text style={{ fontSize: '7px', textAlign: 'center' }}>SANTIAGO DE SURCO - LIMA</Text>
                                    <Text style={{ fontSize: '7px', fontWeight: '600' }}>TELEFONO(S): 6171700</Text>
                                    <Text style={{ fontSize: '7px' }}>PAGINA WEB: www.llamagas.com.pe</Text>
                                    <Text style={{ fontSize: '7px' }}>E-MAIL:  sac@grupollamagas.pe</Text>
                                    <Text style={{ fontSize: '7px' }}>SUCURSAL: {_user?.Sucursal || ''}</Text>
                                    <Text style={{ fontSize: '7px' }}>DIRECCIÓN SUCURSAL: {_user?.DireccionSucursal || ''}</Text>
                                </View>

                                <View style={[styles.col4, { paddingRight: '10px', paddingTop: '5px' }]}>
                                    <View style={{ borderWidth: '1', borderColor: '#000000', padding: '5px' }}>
                                        <Text style={{ fontSize: '7px', textAlign: 'center' }}>{'RUC: 20100366747'}</Text>
                                        <Text style={{ fontSize: '7px', fontWeight: 'bold', textAlign: 'center' }}>{'FACTURA'}</Text>
                                        <Text style={{ fontSize: '7px', textAlign: 'center' }}>{'ELECTRONICA'}</Text>
                                    </View>
                                </View>

                            </View>

                            <View style={[styles.content, { paddingLeft: '5px', paddingTop: '10px', border: '1px solid black', marginTop: '10px' }]}>
                                <View style={{ display: 'flex', flexDirection: 'row' }}>
                                    <View style={{ width: '50%' }}>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>CLIENTE</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.CardName || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '48%' }}>DIRECCIÓN</Text>
                                            <Text style={{ fontSize: '7px' }}>: {header.Address || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>RUC</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.LicTradNum || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>FECHA DE EMISIÓN</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.DocDate || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>HORA DE EMISIÓN</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {formatDocTime(header.DocTime) || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>FECHA DE VENCIMIENTO</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.DocDueDate || ''}</Text>
                                        </View>
                                    </View>

                                    <View style={{ width: '50%', paddingLeft: '20px', paddingTop: '41px' }}>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>MONEDA</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.DocCur || ''}</Text>
                                        </View>
                                        <View style={{ display: 'flex', flexDirection: 'row', paddingBottom: '3px' }}>
                                            <Text style={{ fontSize: '7px', fontWeight: 'bold', width: '35%' }}>FORMA DE PAGO</Text>
                                            <Text style={{ fontSize: '7px', flex: 1 }}>: {header.condicionesPago || ''}</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </>
        );
    }

    return (
        <>

            <View style={styles.tableContainer}>
                <View style={[styles.content]}>
                    <View style={[styles.col]}>
                        <View style={[styles.content]}>
                            <View style={[styles.col6]}>
                                <Image style={styles.logo} src={development ? require('../../images/logo_draft.png') : require('../../images/logo_EMPRESA.png')} />
                            </View>
                            {header.ObjType === "1250000001" &&

                                <View style={[styles.col6, {textAlign: 'right', alignContent: 'right', fontWeight: 'bold', fontSize: '15px'}]}>
                                    {/* <Image style={styles.logo} src={development ? require('../../images/logo_draft.png') : require('../../images/logo_EMPRESA.png')} /> */}
                                    <Text>Solicitud de Traslado</Text>
                                </View>

                            }

                        </View>

                        <View style={[styles.content, { paddingLeft: '2px', paddingTop: '5px' }]}>
                            <View style={[styles.col6, styles.textLeft]}>
                                <Text>{`SUCURSAL: ${_user?.Sucursal.toUpperCase()} `}</Text>
                                <Text>{_user?.Branch.Address.toUpperCase()}</Text>
                                <Text>{`C.P. ${_user?.Branch.ZipCode || 'Sin código postal'} `}</Text>
                                <Text>{_user?.Branch.Phone || 'Sin número de teléfono'}</Text>
                            </View>
                            <View style={[styles.col1, styles.textLeft]}>
                            </View>
                            <View style={[styles.col5, styles.textLeft]}>
                                <View style={[styles.content]}>
                                    <View style={[styles.col7]}>
                                        <Text>{`${TitleModal(header.ObjType, header)} N°:`}</Text>
                                    </View>
                                    <View style={[styles.col5]}>
                                        <Text style={{ fontStyle: 'bold' }}>{`${header.DocNum}`}</Text>
                                    </View>
                                </View>
                                {header.ObjType !== '24' && header.ObjType !== '67' && header.ObjType !== '59' && header.ObjType !== '60' && header.ObjType !== "1250000001" &&
                                    <>
                                        <View style={[styles.content]}>
                                            <View style={[styles.col7]}>
                                                <Text>Estatus:</Text>
                                            </View>
                                            <View style={[styles.col5]}>
                                                <Text style={{ fontStyle: 'bold' }}>{`${header.DocStatus === 'C' ? 'Cerrado' : 'Abierto' || ''}`}</Text>
                                            </View>
                                        </View>
                                        < View style={[styles.content]}>
                                            <View style={[styles.col7]}>
                                                <Text>Folio:</Text>
                                            </View>
                                            <View style={[styles.col5]}>
                                                <Text style={{ fontStyle: 'bold' }}>{`${header.NumAtCard || ''}`}</Text>
                                            </View>
                                        </View>
                                    </>
                                }
                                {header.ObjType === "1250000001" &&
                                    <>
                                        < View style={[styles.content]}>
                                            <View style={[styles.col7]}>
                                                <Text>Almacén de salida:</Text>
                                            </View>
                                            <View style={[styles.col5]}>
                                                <Text style={{ fontStyle: 'bold' }}>{`${header.FromWhsName || ''}`}</Text>
                                            </View>
                                        </View>
                                        < View style={[styles.content]}>
                                            <View style={[styles.col7]}>
                                                <Text>Fecha de entrega:</Text>
                                            </View>
                                            <View style={[styles.col5]}>
                                                <Text style={{ fontStyle: 'bold' }}>{`${header.DocDueDate || ''}`}</Text>
                                            </View>
                                        </View>
                                    </>
                                }
                                {(header.ObjType === '67' || header.ObjType === '59' || header.ObjType === '60') &&
                                    <>
                                        <View style={[styles.content]}>
                                            <View style={[styles.col7]}>
                                                <Text>Fecha:</Text>
                                            </View>
                                            <View style={[styles.col5]}>
                                                <Text style={{ fontStyle: 'bold' }}>{`${header.DocDate || " "}`}</Text>
                                            </View>
                                        </View>
                                        <View style={[styles.content]}>
                                            <View style={[styles.col7]}>
                                                <Text>Folio físico:</Text>
                                            </View>
                                            <View style={[styles.col5]}>
                                                <Text style={{ fontStyle: 'bold' }}>{`${header.U_FolioFisico || " "}`}</Text>
                                            </View>
                                        </View>
                                    </>
                                }

                            </View>
                        </View>

                        {(header.ObjType !== '67' && header.ObjType !== '59' && header.ObjType !== '60' && header.ObjType !== "1250000001") &&
                            <View style={[styles.content, { paddingLeft: '2px', paddingTop: '5px' }]}>
                                <View style={[styles.col5]}>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`Cliente: ${header.CardCode || ""} `}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`Nombre: ${header.CardName || ""} `}</Text>
                                    </View>
                                    <View >
                                        <Text style={[styles.textLeft]}>{`Dirección: ${header.Address || ""}`}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`RUT: ${header.LicTradNum || ""}`}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`Teléfono: ${header.Phone1 || ""}`}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`Contacto: ${header.CntntName || ""}`}</Text>
                                    </View>
                                </View>
                                <View style={[styles.col7]}>
                                    <View style={[styles.content]}>
                                        <View style={[styles.col4]}>
                                            <View>
                                                <Text style={[styles.textRight]}>{`Fecha: `}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textRight]}>{`Condición de Pago: `}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textRight]}>{`Moneda: `}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textRight]}>{`Lugar de entrega: `}</Text>
                                            </View>
                                        </View>
                                        <View style={[styles.col8]}>
                                            <View>
                                                <Text style={[styles.textLeft]}>{`${header.DocDate || " "}`}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textLeft]}>{`${header.condicionesPago || " "}`}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textLeft]}>{`${header.DocCur || header.DocCurr || " "}`}</Text>
                                            </View>
                                            <View>
                                                <Text style={[styles.textLeft]}>{`${header.Address2 || " "}`}</Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        }

                        {(header.ObjType === '67') &&
                            <View style={[styles.content, { paddingLeft: '2px', paddingTop: '5px' }]}>
                                <View style={[styles.col5]}>
                                    <View>
                                        <Text style={[styles.textLeft]}>{` `}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{`${header.Empleado ? header.Empleado.toUpperCase() : ""} `}</Text>
                                    </View>
                                    <View >
                                        <Text style={[styles.textLeft]}>{`Origen: ${header.Filler || ""}`}</Text>
                                        <Text style={[styles.textLeft]}>{`${header.Origin !== null && header.Destination !== null && header.Origin !== '' ? 'Almacén Origen: ' + header.Origin : '' || ""}`}</Text>
                                        <Text style={[styles.textLeft]}>Peso total: {Number(weightTotal || 0).toFixed(3)}</Text>
                                    </View>

                                </View>
                                <View style={[styles.col4]}>

                                </View>
                                <View style={[styles.col7]}>
                                    <View>
                                        <Text style={[styles.textLeft]}>{` `}</Text>
                                    </View>
                                    <View>
                                        <Text style={[styles.textLeft]}>{` `}</Text>
                                    </View>
                                    <View >
                                        <Text style={[styles.textLeft]}>{`Destino: ${header.ToWhsCode || " "} `}</Text>
                                        <Text style={[styles.textLeft]}>{`${header.Origin !== null && header.Destination !== null && header.Destination !== '' ? 'Almacén Destino Final: ' + header.Destination : '' || ""}`}</Text>
                                    </View>
                                </View>
                            </View>
                        }


                    </View>
                </View>
            </View>
        </>);
    }

export default ReportTitle;